import Entity from "../../engine/entity";
import Hitbox from "../../engine/hitbox";
import SimplexNoise from "simplex-noise";
import CtxTexture from "/src/js/engine/2d/ctxTexture";

import textureURL from "url:/src/img/black-guitar.png";
import textureMaskURL from "url:/src/img/black-guitar-mask.png";

import Rocket from "./rocket";
import Explosion from "./explosion";

import rocketSFXURL from "url:/src/sounds/rocket.mp3";
import deathSFXURL from "url:/src/sounds/boss-death.mp3";
import gsap from "gsap/gsap-core";
import gameover from "../gameover";

export default class Boss extends Entity{
    constructor({engine, music, player}){
        super({engine,type:"boss"});
        this.position = {x: this.engine.width * 0.75, y: this.engine.height * 0.5};
        this.offset = this.engine.width * 0.5;
        this.hitbox = new Hitbox({...this.position, w:100, h:100 });
        this.noise = new SimplexNoise("boss");
        this.maxHp = 200;
        this.hp = this.maxHp;
        this.hpBarsDOM = document.getElementById("boss-hp").querySelectorAll(".healthbar__inner div");
        this.texture = new CtxTexture(textureURL);
        this.textureMask = new CtxTexture(textureMaskURL);
        this.rotation =  0;
        this.direction = {x: 500, y: 0};
        this.music = music;
        this.hitted = false;
        this.player = player;

        this.fireTimer = 0;
        this.dying = false;

        this.time = 0;
    }

    update(){
        if(!this.dying){
            let x = (this.noise.noise2D(0,(this.engine.time.time - .5) * 0.2) + 1) * 0.5 * this.engine.width * 0.5 + this.engine.width * 0.5  + this.offset;
            let y = (this.noise.noise2D((this.engine.time.time - .5) * 0.2, 0) + 1) * 0.5 * this.engine.height;

            this.position.x = (this.noise.noise2D(0,this.engine.time.time * 0.2) + 1) * 0.5 * this.engine.width * 0.5 + this.engine.width * 0.5 + this.offset;
            this.position.y = (this.noise.noise2D(this.engine.time.time * 0.2, 0) + 1) * 0.5 * this.engine.height;

            let direction = {x: x - this.position.x, y: y - this.position.y};
            this.direction.x += (direction.x - this.direction.x) * 0.1;
            this.direction.y += (direction.y - this.direction.y) * 0.1;

            this.rotation = Math.atan2(-this.direction.y, this.direction.x + 500);
            
            this.fireTimer += this.engine.time.delta;

            if(this.fireTimer > 1.5 + 18.5 * (this.hp/this.maxHp)){
                this.fireTimer = 0;
                new Rocket({engine: this.engine, position: this.position, player: this.player});
                const sfx = new Audio(rocketSFXURL);
                sfx.volume = 0.5;
                sfx.play();
            }

            this.collision();
        }else{

            this.hitted = Math.sin(this.engine.time.time * 50) > 0;
            this.rotation += this.engine.time.delta * (Math.PI/180) * 180;

            this.fireTimer += this.engine.time.delta;
            if(this.fireTimer > .02){
                const s = this.engine.scaleFactor;
                this.fireTimer = 0;
                const pos = {...this.position};
                const angle = Math.random() * Math.PI * 2;
                const dist = Math.random() * 100;
                pos.x -= 120 * s + Math.cos(angle) * dist;
                pos.y += 50 * s + Math.sin(angle) * dist; 
                new Explosion({engine: this.engine, position: pos, size: 100 + Math.random() * 200});
            }
        }

        this.engine.renderer.passes[0].material.uniforms.boss_position.value = [this.position.x/this.engine.width, this.position.y/this.engine.height];


        this.updateUI();
    }

    collision(){
        this.engine.entities.forEach(e => {
            if(e.type == "bullet" && e.hitbox.overlaps(this.hitbox)){
                e.hit();
                this.hp--;
                this.hitted = true;
                clearTimeout(this.hitTimeout);
                this.hitTimeout = setTimeout(()=>this.hitted = false, 30);
                e.player.addScore();
                if(this.hp <= 0){
                   this.death();
                }
            }
        });
    }

    death(){
        this.dying = true;
        this.music.stop();
        new Explosion({engine: this.engine, position: this.position, size: 2000});
        gsap.timeline()
            .to(".hud",{duration: 1.5, autoAlpha: 0, ease:"power3.inOut" },"0")
            .to(this.position,{duration:5, y: this.position.y + window.innerHeight, x: this.position.x - 1000, ease:"power1.in" },"0")
            .to(this.player,{duration:2, rotation: 0 },"0")
            .to(this.player.position,{duration:2, y: window.innerHeight / 2, x: window.innerWidth * 1.5, ease:"power4.in" },"1");
        this.engine.entities.forEach(e =>{
            if(e.type == "note"){
                setTimeout(()=>{
                    e.kill();
                },500 * Math.random());
            }else if(e.type == "rocket"){
                e.kill();
            }
        });
        this.player.gameover = true;
        const sfx = new Audio(deathSFXURL);
        sfx.volume = 1;
        sfx.play();
        gameover({win: true, score: this.player.score, time: this.player.scoreTime});
    }

    updateUI(){
        const percent = ((1-this.hp/this.maxHp) * 100);
        this.hpBarsDOM[0].style="transform: translateX(-"+ percent +"%);";
        this.hpBarsDOM[1].style="transform: translateX(-"+ percent +"%);";
    }

    render(ctx){
        if(!this.texture.ready) return;
        const s =  this.engine.scaleFactor;
        const texSize = 300 * s;
        const texOffset = 75 * s;
        const glowRadius = (400 * this.music.analyser.data.rawvolume) * s;

        ctx.save();
        ctx.translate(this.position.x - texOffset, this.position.y);
        ctx.rotate(this.rotation);
                
        //light
        const gradient = ctx.createRadialGradient(texOffset, 0, 0, texOffset, 0, glowRadius);
        gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)');
        gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(-glowRadius + texOffset, -glowRadius, glowRadius * 2, glowRadius * 2);

        this.drawAura(ctx);

        ctx.shadowBlur = 20 * s  * this.music.analyser.data.rawvolume;
        //texture
        this.texture.draw(ctx, texSize);
        ctx.globalAlpha = 0.5;
        if(this.hitted) this.textureMask.draw(ctx, texSize);
        ctx.globalAlpha = 1;
        ctx.restore();


        //Update hitbox
        this.hitbox.set({...this.position, w: 100 * s, h: 100 * s});
    }

    drawAura(ctx) {
        const s =  this.engine.scaleFactor;
        const offset = 100 * s;
        const size = 150 * s;
        let values = this.music.analyser.extractData({min:0,max:50});
        ctx.beginPath();
        for (let i = 0; i < values.length; i++) {
            let angle = i / values.length * Math.PI;
            let x = - Math.cos(angle) * values[i]/255 * size + offset;
            let y = Math.sin(angle) * values[i]/255 * size;
            ctx.lineTo(x, y);
        }
        for (let i = values.length - 1; i >= 0 ; i--) {
            let angle = -i / values.length * Math.PI;
            let x = - Math.cos(angle) * values[i]/255 * size + offset;
            let y = Math.sin(angle) * values[i]/255 * size;
            ctx.lineTo(x, y);
        }
        ctx.shadowColor = "red";
        ctx.shadowBlur = 20 * s;

        ctx.lineWidth = 1;
        ctx.strokeStyle = "red";
        ctx.stroke();
        ctx.beginPath();
    }
}